import { useMediaQuery } from "@mui/material";
import JCTaskSummary from "../taskDetailsJobCard/JCTaskSummary";
import DrawerHeader from "../../../components/atoms/DrawerHeader";
var TaskSummaryJc = function (props) {
    var onCrossClick = props.onCrossClick, id = props.id, jobCardData = props.jobCardData, isCrossIcon = props.isCrossIcon, isHeaderShown = props.isHeaderShown, onClose = props.onClose;
    var IS_MOBILE = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, !IS_MOBILE && /*#__PURE__*/ React.createElement(DrawerHeader, null), /*#__PURE__*/ React.createElement(JCTaskSummary, {
        onCrossClick: onClose,
        jobCardId: id,
        jobCardData: jobCardData,
        isCrossIcon: isCrossIcon,
        isHeaderShown: isHeaderShown
    }));
};
export default TaskSummaryJc;
